import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import type { WithdrawalPaymentFile } from '../../models';
import { PaymentFileCard } from './PaymentFileCard';

interface PaymentFileCardListProps {
  paymentFiles: WithdrawalPaymentFile[];
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  total?: number;
  showActions?: boolean;
  estimateItemHeight?: number;
  onViewDetail?: (file: WithdrawalPaymentFile) => void;
  onDownload?: (file: WithdrawalPaymentFile) => void;
  downloadingFileId?: number | null;
}

/** Lista virtual de ficheros de pago para móvil - Virtual payment files list for mobile */
export const PaymentFileCardList = ({
  paymentFiles,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  total,
  className = '',
  showActions = true,
  estimateItemHeight = 200,
  onViewDetail,
  onDownload,
  downloadingFileId,
}: PaymentFileCardListProps) => {
  const { t } = useTranslation('withdrawalPaymentFilesModule');

  const renderPaymentFileCard = (props: RenderItemProps<WithdrawalPaymentFile>) => (
    <PaymentFileCard
      {...props}
      showActions={showActions}
      onViewDetail={onViewDetail}
      onDownload={onDownload}
      downloadingFileId={downloadingFileId}
    />
  );

  const getPaymentFileKey = (file: WithdrawalPaymentFile) => file.id;

  return (
    <VirtualList
      data={paymentFiles}
      renderItem={renderPaymentFileCard}
      itemKey={getPaymentFileKey}
      estimateItemHeight={estimateItemHeight}
      height="calc(100vh - 200px)"
      gap={0}
      emptyMessage={t('empty.message')}
      className={`rounded-lg ${className}`}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
